import { navigationPostHook } from "./hooks/navigationPostHook";

const hooks = [navigationPostHook];

export default hooks;
